import React, { useState } from 'react'
import {
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  DialogContentText,
  Button,
  Box,
} from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Delete'
import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles((theme) => ({
  deleteButton: {
    color: theme.palette.text.secondary,
    transition: 'all 0.2s ease',
    '&:hover': {
      color: theme.palette.error.main,
      backgroundColor: theme.palette.error.light + '15',
      transform: 'scale(1.05)',
    },
  },
  dialog: {
    '& .MuiDialog-paper': {
      borderRadius: theme.spacing(1),
    },
  },
  deleteConfirmButton: {
    fontWeight: 600,
  },
}))

const DeleteFileButton = ({ onClickConfirm }) => {
  const classes = useStyles()
  const [dialogOpen, setDialogOpen] = useState(false)

  const handleClickDelete = () => {
    setDialogOpen(true)
  }

  const handleCloseDialog = () => {
    setDialogOpen(false)
  }

  const handleClickConfirm = () => {
    setDialogOpen(false)
    onClickConfirm()
  }

  return (
    <>
      <IconButton className={classes.deleteButton} onClick={handleClickDelete} size="small">
        <DeleteIcon fontSize="small" />
      </IconButton>
      <Dialog open={dialogOpen} onClose={handleCloseDialog} className={classes.dialog} maxWidth="sm">
        <DialogTitle>
          <Box display="flex" alignItems="center" gap={1}>
            <DeleteIcon color="error" fontSize="small" />
            Delete File
          </Box>
        </DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ mb: 1 }}>Are you sure you want to delete this file?</DialogContentText>
          <DialogContentText sx={{ mb: 1 }}>This will delete the file and all associated analyses.</DialogContentText>
          <DialogContentText>
            <strong>This action cannot be undone.</strong>
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ p: 2, gap: 1 }}>
          <Button onClick={handleCloseDialog} variant="outlined">
            Cancel
          </Button>
          <Button
            onClick={handleClickConfirm}
            variant="contained"
            color="error"
            className={classes.deleteConfirmButton}
            autoFocus
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default DeleteFileButton
